export const DEFAULT_MENU_WIDTH = [232, 64];
